import { isIgnored } from './is-ignored';
export var isValidTargetNode = function (node) {
    return !!node && !isIgnored(node);
};
//# sourceMappingURL=is-valid-target-node.js.map